import React from "react";
import { Route } from "react-router-dom";
import PurchaseReturn from "../../../containers/modules/purchasing/purchase-return";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function PurchaseReturnRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="purchase-return"
      index
      element={
        <AccessControl
          name={"Purchase Return List"}
          auth={authUser}
          component={() => <PurchaseReturn />}
        />
      }
    ></Route>
  );
}
